export default __webpack_public_path__ + "static/report-image-three-27b1dac1cb181251ad71be1fc463cd0f.png";